<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="5">
          <b-form-group
            description="Choose from different themes for the card images."
          >
            <label>Theme Selection:</label>
            <b-form-select
              id="match-groups"
              v-model="settingsUser.matchGroup"
              :options="themes"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group
            description="Select the size of the card grid, including options like 4x4, 6x6, or other grid dimensions. Larger grids can be more challenging."
          >
            <label>Card Grid Size</label>
            <b-form-spinbutton
              id="match-size"
              v-model="settingsUser.gridSize"
              :min="gridSizeMin"
              :max="gridSizeMax"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group>
            <label
              v-for="(aToggle, i) in toggles"
              class="notification"
              :value="aToggle.name"
              :key="`tog_${i}`"
            >
              <div class="toggler" :class="[aToggle.value ? 'bg' : '']">
                <div
                  class="slider"
                  :class="[aToggle.value ? 'btns' : '']"
                ></div>
              </div>
              <div class="notification-content">
                <h6>{{ aToggle.name }}</h6>
                <p>
                  {{ aToggle.text }}
                </p>
              </div>
              <input
                type="checkbox"
                class="invisible"
                v-model="aToggle.value"
              />
            </label>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
export default {
  name: "Settings_SimonGame",
  mixins: [ResourceBlockSettings],
  data() {
    return {
      settingsUser: {
        gridSize: 2,
        theme: "fruits"
      },
      //****** App Specific
      gridSizeMin: 2,
      gridSizeMax: 5,
      themes: [
        { value: "fruits", text: "Fruits" },
        { value: "animals", text: "Animals" },
        { value: "logos", text: "Logos" },
        { value: "colors", text: "Colors" },
        { value: "holidays", text: "Holidays" }
      ],
      value: 0,
      toggles: [
        {
          name: "Sound Effects:",
          description: "Sound effects during gameplay",
          property: "_isSoundOn",
          type: "btns",
          text: "Turn on the Sound",
          isAvail: true,
          value: false
        },
        {
          name: "Background music while playing:",
          description: "Toggle sound effects on or off during gameplay",
          property: "_hasBGMusic",
          type: "btns",
          text: "Turn on the Sound",
          isAvail: true,
          value: false
        },
        {
          name: "Progress Stats",
          property: "_isDisplayStats",
          type: "btns",
          text: "Display their turns, times, scores ",
          isAvail: true,
          value: false
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
